import ShareCampaign from './share_campaign_compact'
import { connect } from 'react-redux'
import {
  campaignUrlForDisplay,
  campaignUrlWithMeDomain,
} from 'lib/campaign_url'
import { canShareSelector } from 'redux/selectors/share'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, ownProps) => {
  const canShare = canShareSelector(state)
  const campaign = getCampaignSelector(state, ownProps)

  let props = {
    shareable: true,
    shareUrl: campaignUrlWithMeDomain(campaign.id),
    displayUrl: campaignUrlForDisplay(campaign.id),
    appId: state.social.app_id,
  }

  if (!canShare) {
    props.showFacebook = false
    props.showMessenger = false
    props.showTwitter = false
    props.showWhatsApp = false
    props.showEmail = false
    props.showSms = false
  }

  return props
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareCampaign)
